"use client"

import { useRef } from "react"

import { hashKey } from "@tanstack/react-query"

import { useViewer } from "@/platform/session/use-viewer"
import { privateKey, UNRESOLVED_VIEWER } from "@/platform/session/viewer"

import type { QueryClient } from "@tanstack/react-query"

export const usePrivateKey = (...parts: readonly unknown[]) => {
  const key = privateKey(useViewer() ?? UNRESOLVED_VIEWER, ...parts)
  const hash = hashKey(key)
  const stable = useRef({ hash, key })
  if (stable.current.hash !== hash) stable.current = { hash, key }
  return stable.current.key
}

export const invalidateDomain = (queryClient: QueryClient, ...domains: readonly string[]): Promise<void> =>
  queryClient.invalidateQueries({
    predicate: (query) => typeof query.meta?.viewer === "string" && domains.includes(String(query.queryKey[1])),
  })
